import React, { useState, useEffect } from "react";
import AdminWrapper from "../AdminWrapper";
import SwitchMenuBar from "../../../Components/SwitchMenuBar/SwitchMenuBar";
import { tableMake } from "../../Statistics/statisticsTable";
import { API } from "../../../API";
import { StylesStatistics, StylesTable } from "../../Statistics/styled";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import {Refresh} from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';
import Modal from "../../../Components/Modal/Modal";
import moment from "moment";
import { notify } from "react-notify-toast";

const AllocateET = () => {
  const [allocateETData, setAllocateETData] = useState({});
  const [showTestBook, setShowtestBook] = useState(false);
  const [rowID, setRowID] = useState('');
  const [teacher, setTeacherID] = useState('');
  const [loading, setloading] = useState(false);
  const [solutions, setsolutions] = useState([]);
  const [modal,setmodal] = useState(false)
  const [legend,setLegend] = useState(false)
  const [aiTitle,setaiTitle] = useState('Loading ')
  const [lastUpdate,setLastupdate] = useState(moment().format('hh:mm:ss'))
  const [allTeachers, setAllTeachers] = useState([])
  const [bookingID, setBookingID] = useState('');

  useEffect(async () => {
    await getAllocate();
    await getAllUsers()
  }, []);

  const getAllocate = async () => {
    try {
      setloading(true)
      const { data } = await API.allocateET();

      const summariesData = data?.data?.summary
      if (summariesData?.length && Array.isArray(summariesData)) {
        const summaries = summariesData.map(summary => {
          const bookingDetail = data?.data?.details?.[summary.id]?.[0]
  
          if (bookingDetail?.multiple_date) {
            const teachers = summary.Teachers.map(teacher => {
              const dates = bookingDetail.dates
              dates.forEach(date => {
                if (date.is_rdo && date.teacher_id === teacher.id) {
                  teacher.status = 'RDO'
                }
              
                if (date.teacher_response == 'rejected' && date.teacher_id === teacher.id && !date.is_rdo) {
                  teacher.status = 'Rejected'
                }
              })
    
              return teacher
            })
            summary.teachers = teachers
  
            return summary
          }
  
          return summary
        })
  
        data.data.summaries = summaries
      }

      setAllocateETData(data.data);
      setloading(false)
      setTimeout(()=>{
        getAllocate()
        setLastupdate(moment().format('hh:mm:ss'))
      }, 5*60*1000)
      const newBooking = data.data.summary.length
      const test = data.data.summary.filter(obj => 
        (obj.Institute === 'ReadyTeacherTest') ||
        (obj.Institute === 'ECEC Test')
        ).length
      if(newBooking - test > 0){
        showNotification(newBooking-test)
      }
    } catch (error) {
      console.log('getAllocate ERR', error);
    }
  };

  const getAllUsers = async () => {
		try {
			await API.allTeachersSearchableForAllocate()
				.then(function (result) {
					let users = result.data
						.filter((user) => {
							return user.first_name || user.last_name;
						})
						.sort((a, b) => {
							let nameA = (a.first_name + " " + a.last_name).toLowerCase();
							let nameB = (b.first_name + " " + b.last_name).toLowerCase();
							return nameA > nameB ? 1 : -1;
						});

            setAllTeachers(users);
				})
				.catch(function (err) {
					console.log(err);
				});
		} catch (error) {
			alert(error);
		}
	};

  const assignAI = async (id) => {
    try {
      setsolutions([])
      setmodal(true)
      setaiTitle('Loading ')
      setBookingID(id)
      const { data } = await API.allocateAI(id);
      setaiTitle('')
      setsolutions(data.data.solutionsH)
    } catch (error) {
      console.log('assignAI ERR', error);
    }
  };
  const setRow = (id) =>{
    id == rowID ? setRowID('') : setRowID(id)
  }
  const setTeacher = (id, institutionName) => {
    const teacher = allTeachers.find(teacher => `${teacher.first_name} ${teacher.last_name}` == id)
    if (teacher && teacher?.level === "senior" && institutionName == "Wattle College") {
      notify.show("Cannot assign senior teacher for this institution")
      return
    }
    setTeacherID(id)
  }

  const showNotification = (number) => {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('New Booking!', {
        body: `You have ${number} Unassigned Bookings`,
        icon: '../../../assets/img/logo_right.jpeg'
      });
    }else{
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          showNotification(number);
        }
      });
    }
  };
  const getBudgetLevelColor = (teacherLevel, maximumSpend) => {
    const levels = {
      'junior': 1,
      'senior': 2, 
      'expert': 3,
      'master': 4
    };

    const spendLevel = levels[maximumSpend?.toLowerCase()];
    const checkLevel = levels[teacherLevel?.toLowerCase()];

    if (!spendLevel || !checkLevel) {
      return '';
    }

    return checkLevel > spendLevel ? 'danger' : '';
  };

  function Suggestion( suggestions ) {
    let color = ''
    if(suggestions?.length > 0 && typeof(suggestions) !== 'string') {
      const bookingDetails = allocateETData?.details?.[bookingID]?.[0];

      return (
        <div>
          {bookingDetails?.budget && (
            <div className="booking-details p-3 mb-3 bg-gray-50 rounded-lg border border-gray-200">
              <div className="grid grid-cols-2 gap-2">
                <div className="budget-item">
                  <span className="font-semibold text-gray-700">Budget Level:</span>
                  <span className="ml-2 text-blue-600">{bookingDetails?.budget?.maximum_spend}</span>
                </div>
                <div className="budget-item">
                  <span className="font-semibold text-gray-700">Action:</span>
                  <span className="ml-2 capitalize text-blue-600">
                    {bookingDetails?.budget?.action?.replaceAll('_', ' ')}
                  </span>
                </div>
              </div>
            </div>
          )}
          {suggestions.map((sug, i) => (
            <div key={i} className="row border-top mt-2">
              {Object.keys(sug).map((j) => {
                if (j !== 'score' && j !== 'consistency' && j !== 'assign' && j !== 'sugID') {
                  const title = sug[j][0].Name.replace(/"/g, '');
                        color = sug[j][1];
                  let budgetColor = getBudgetLevelColor(sug[j][0].Level, bookingDetails?.budget?.maximum_spend);
                  return (
                    <>
                    <div key={j} className="col">
                      <button
                        type="button"
                        className={`btn btn-sm btn-outline-${color} mt-3 btn-block`}
                        data-toggle="tooltip"
                        data-placement="top"
                        title={title}
                      >
                        {j.replace(/\^2023-/, '')}
                        <br />
                        {sug[j][0].Name.substring(0, 10)}
                      </button>
                    </div>
                    <div key={j} className="col mt-3">
                      <span style={{ color: 'black' }}>Level: </span>
                      <span className={`text-${budgetColor ? budgetColor :color} text-decoration-none`}>
                        {sug[j][0].Level}
                      </span>
                    </div>
                    </>
                  );
                }
                return null;
              })}
              <div className="col mt-3">
                <a>
                  <span style={{ color: 'black' }}>
                    Score: <b>{sug.score}</b>
                  </span>
                </a>
              </div>
              <div className="col mt-3">
                <a>
                  <span style={{ color: 'black' }}>Consistency: </span>
                  <span className={`text-${color} text-decoration-none`}>
                    {sug.consistency}
                  </span>
                </a>
              </div>
              <div className="col mt-3">
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={() => assign(sug.sugID)}
                >
                  Assign
                </button>
              </div>
            </div>
          ))}
        </div>
      );
    }else if (typeof(suggestions) === 'string'){
      return (
        <div>
          <div className="col mt-3">
            <a><b>
              <span style={{ color: 'orange' }}>{ suggestions }</span>
            </b></a>
          </div>
        </div>
      )
    }else{
      return (
        <div>
          <div className="col mt-3">
            <a><b>
              <span style={{ color: 'orange' }}>{aiTitle != 'Loading ' ? 'No Suggestions' : null }</span>
            </b></a>
          </div>
        </div>
      )
    }
  }

  const tableLegend = () => {
    return (
      <StylesStatistics>
        <div className="legend-section">
          <div><strong>Teacher:</strong></div>
          <div><span className={`${'text-success'}`}>The Preferred Teacher Has CanDeliver and Has Updated the Availability</span></div>
          <div><span className={`${'text-purple'}`}>The Preferred Teacher Does NOT Have CanDeliver but is Available</span></div>
          <div><span className={`${'text-warning'}`}>The Preferred Teacher Has CanDeliver but is NOT Available</span></div>
          <div><span className={`${'text-danger'}`}>The Preferred Teacher Does NOT Have CanDeliver and is NOT Available</span></div>
          <div><span className={`${'text-white bg-secondary'}`}>The Teacher is in the BLOCK List</span></div>
        </div>
        <div className="legend-section">
          <div><strong>Booking:</strong></div>
          <div><span className={`${'bg-primary'}`}>Normal Booking</span></div>
          <div><span className={`${'bg-warning'}`}>MorningET Booking</span></div>
          <div><span className={`${'bg-danger'}`}>Gold Coast Booking</span></div>
          <div><span className={`${'text-white bg-secondary'}`}>Test Booking</span></div>
        </div>
      </StylesStatistics>
    );
  };
  
  

const assign = async (id) =>{
  const assignment = solutions.find(obj => obj.sugID === id);
  const postBody = assignment.assign[0]
  const {data} = await API.assignAI(postBody);
  setsolutions(data.data)
  setTimeout(()=>{
    setmodal(false)
    getAllocate()
  },2000)
}

  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <StylesStatistics>
      <Modal
        header={aiTitle + 'AI Suggestions'}
        onClose={() => setmodal(false)}
        // className="confirm-number-modal"
        show={modal}
      >
        {Suggestion(solutions)}
      </Modal>
      <Modal
        header={'Legend'}
        onClose={() => setLegend(false)}
        show={legend}
      >
        {tableLegend()}
      </Modal>
      <div className="body-main-page-JobList">
        <div className="d-flex justify-center my-2">
          <p className="text-3xl font-bold flex flex-col justify-center ml-10">
            Allocate
          </p>
        </div>
        <div className="d-flex flex-row overflow-auto collapse-check-buttons justify-between">
          <button 
          id="refresh"
          onClick={() => getAllocate()}
          className="refresh-button"
          >
          {loading ? <CircularProgress size={20} color="inherit"/> : <Refresh sx={{ color: "#000" }} />}
          Last Update: {lastUpdate}
          </button>
					<CheckableButton
						noBorder
						checked={showTestBook}
						onClick={() => setShowtestBook((s) => !s)}
						onChange={(e) => setShowtestBook(e.target.checked)}
					>
						Show Test Bookings
					</CheckableButton>
        </div>
        <div className="row">
          <div 
            id='bookTable'
            className="col statistic-card">
          {tableMake(allocateETData,showTestBook,rowID,setRow,teacher,setTeacher,assignAI)}
          </div>
        </div>
          <button
            onClick={()=> setLegend(true)}
          >View Legend</button>
      </div>
      </StylesStatistics>
    </AdminWrapper>
  );
};

export default AllocateET;
